import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import FeesTrackerPageUI from './FeesTrackerPageUI.js'

class FeesTrackerPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountFeeList: null,
      financialYear: '',
      financialYearList: []
    }
  }

  render() {
    return (
      <FeesTrackerPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountFeeList={this.state.accountFeeList}
        onRefreshClick={this.onRefreshClick}
        financialYear={this.state.financialYear}
        financialYearList={this.state.financialYearList}
        onFinancialYearChange={this.onFinancialYearChange}
      />
    )
  }

  onFinancialYearChange = (option) => {
    let context = this.props.context
    this.setState({ financialYear: option.value })
    this.getProcessingFees(context, option.value)
  }

  componentDidMount() {
    let context = this.props.context
    this.getYears(context)
  }

  getYears(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/years`,
      cacheKey: CacheKeys.Years(),
      callback: this.getYearsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getYearsCallback = (response) => {
    let financialYearList = response.financialYearList.map((years) => {
      return { value: years, label: years }
    })
    this.setState(
      { errorList: response.errorList, financialYearList: financialYearList },
      () => {
        let currentFinancialYear = response.currentFinancialYear
        this.getProcessingFees(this.props.context, currentFinancialYear)
      }
    )
  }

  getProcessingFees(context, financialYear) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/processingFees/financialYears/${financialYear}`,
      cacheKey: CacheKeys.ProcessingFees2(financialYear),
      callback: this.getProcessingFeesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getProcessingFeesCallback = (response) => {
    this.setState({ errorList: response.errorList, accountFeeList: response.accountFeeList, financialYear: response.financialYear })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Years())
    CacheManager.removeObject(CacheKeys.ProcessingFees2(this.state.financialYear))
    this.setState({
      accountFeeList: null,
      errorList: null,
    })
    this.getYears(context)
    this.getProcessingFees(context, this.state.financialYear)
  }
}

export default FeesTrackerPageSF
